import React from 'react';
import Carousel from './Carousel';
import FeaturedInventory from '../pages/FeaturedInventory';
import BestPriceCar from '../pages/BestPriceCar';
import ServiceOffer from '../pages/ServiceOffer';
import CabBookingSection from '../pages/CabBookingSection';
import PopularVehicles from '../pages/PopularVehicles';
import Testimonials from '../pages/Testimonials';
import CtaSection from '../pages/CtaSection ';
import DownloadSection from '../pages/DownloadSection';
import BlogSlider from '../pages/BlogSection';



const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
<Carousel/>
<FeaturedInventory
/>
{/* <BestPriceCar/> */}
<ServiceOffer/>
<CabBookingSection/>
<PopularVehicles/>
<Testimonials/>
{/* <CtaSection/> */}
<DownloadSection/>
<BlogSlider/>
    </div>
  );
};

export default HeroSection;
